<material-navbar menuPosition="dashboard" *ngIf="!settings.get('vebto.customPages.hideNavbar')"></material-navbar>
<div class="page-body container article-body" [innerHTML]="body"></div>